import { BadgeInfo, HandCoins } from 'lucide-react';
import { useEffect } from 'react';
import LayoutAdmin from '../../components/layouts/LayoutAdmin';

import { HoverCard, HoverCardContent, HoverCardTrigger } from '../../components/ui/hover-card';
import BarCharts from './barcharts';
import useAnalytics from '../../stores/useAnalytics';
import useAuth from '../../stores/useAuth';

export default function DashboardPage() {
  const { dataUser } = useAuth();
  const {
    loading,
    fetchMonthlyRevenue,
    fetchAccountReceivable,
    fetchCurrentMonthRevenue,
    currentMonthRevenue,
    accountsReceivable,
  } = useAnalytics();

  useEffect(() => {
    fetchMonthlyRevenue(dataUser?.user_id as string);
    fetchCurrentMonthRevenue(dataUser?.user_id as string);
    fetchAccountReceivable(dataUser?.user_id as string);
  }, [dataUser, fetchAccountReceivable, fetchCurrentMonthRevenue, fetchMonthlyRevenue]);

  return (
    <LayoutAdmin header="Dashboard">
      <div className="flex md:gap-4 gap-2">
        <div className="flex flex-col gap-2 border border-gray-300 rounded-md flex-1 md:p-4 p-2">
          <div className="flex justify-between items-center">
            <p className="text-xs md:text-base w-max">Total Revenue</p>
            <div className="flex justify-center items-center p-1 bg-green-50 text-green-600 rounded">
              <HandCoins className="w-4 h-4 md:w-6 md:h-6" />
            </div>
          </div>
          <div>
            <p className="text-base md:text-2xl font-bold">
              {Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(currentMonthRevenue?.revenue ?? 0)}
            </p>
            <p className="text-xs md:text-sm text-gray-600">
              <span className={currentMonthRevenue?.trend !== 'down' ? 'text-green-600' : 'text-red-600'}>
                {currentMonthRevenue?.trend !== 'down'
                  ? `+${currentMonthRevenue?.percentageChange}%`
                  : `${currentMonthRevenue.percentageChange}%`}
              </span>{' '}
              form last month
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2 border border-gray-300 rounded-md flex-1 md:p-4 p-2">
          <div className="flex justify-between items-center">
            <div className="flex gap-1 items-center justify-center">
              <p className="text-xs md:text-base w-max">Account Receivable</p>
              <HoverCard>
                <HoverCardTrigger>
                  <BadgeInfo className="w-4 h-4 md:w-6 md:h-6" />
                </HoverCardTrigger>
                <HoverCardContent>To check the amount of unpaid invoices from buyers</HoverCardContent>
              </HoverCard>
            </div>
            <div className="flex justify-center items-center p-1 bg-yellow-50 text-yellow-600 rounded">
              <HandCoins className="w-4 h-4 md:w-6 md:h-6" />
            </div>
          </div>
          <div>
            <p className="text-base md:text-2xl font-bold">
              {Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(accountsReceivable?.totalReceivable ?? 0)}
            </p>
            <p className="text-xs md:text-sm text-gray-600">
              {accountsReceivable?.invoiceCount ? (
                <>
                  <span className="text-yellow-600">{accountsReceivable?.invoiceCount}</span> Unpaid
                </>
              ) : (
                ''
              )}
            </p>
          </div>
        </div>
      </div>
      <BarCharts />
    </LayoutAdmin>
  );
}
